export default "__VITE_ASSET__DgPMarnP__"